import { useState, useCallback } from "react"
import { navigate } from "gatsby"

import useTracking from "hooks/useTracking"
import { identifyUser } from "utils/identifyUser"

const useEmailSubscription = (trackingId) => {
  const [subscribing, setSubscribing] = useState(false)
  const [subscribed, setSubscribed] = useState(false)
  const [subscribedEmail, setSubscribedEmail] = useState(null)
  const [error, setError] = useState(null)

  const { track } = useTracking()

  const subscribeEmail = useCallback(
    async (email, list, source, props, redirect, multiListSignupForms) => {
      setSubscribing(true)
      setError(null)

      try {
        const response = await fetch(`/api/account/email-signup`, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            forms: multiListSignupForms?.length > 0 ? multiListSignupForms : [{ list, source }],
            ...props,
          }),
        })

        if (!response.ok) {
          throw new Error(response.statusText)
        }

        const { user } = await response.json()
        if (user) {
          await identifyUser({ user })
        }

        if (multiListSignupForms?.length > 0) {
          multiListSignupForms.forEach(({ list: mlList, source: mlSource }) => {
            track("Email Registered", {
              signup_source: mlSource,
              category: "Registration",
              element_id: trackingId,
              list: mlList,
              email,
            })
          })
        } else {
          track("Email Registered", {
            signup_source: source,
            category: "Registration",
            element_id: trackingId,
            list,
            email,
          })
        }

        try {
          const d = window.gtmDataLayer || window.dataLayer || []
          d.push({ event: "emailRegistered", signup_source: source })
        } catch (err) {
          // ignore
        }

        setSubscribed(true)
        setSubscribedEmail(email)

        if (redirect) {
          navigate(redirect)
        }
      } catch (err) {
        setError(true)
        console.error(err)
      }

      setSubscribing(false)
    },
    [track, trackingId],
  )

  return [subscribing, subscribed, error, subscribeEmail, subscribedEmail]
}

export default useEmailSubscription
